module.exports = __webpack_public_path__ + "d48bd65d81f0ab3033ac1b46d61ca444.jpg";